<template>

  <div>
    <div>
      <div class="mb-2">
        {{ $t('Overall status') }}:
        <strong
          :class="statusStyle(approvalflow.status).style">
            {{ statusStyle(approvalflow.status).name }}
          </strong>
      </div> 
      <ul class="approval-list">
        <li
          v-for="(group, index) in approvalflow.groups"
          :key="index">
        
          <div class="group-number">{{ index + 1 }}</div>
        
          <div class="group-header">
            <div
              class="status"
              :class="statusStyle(group.status).style">
                {{ statusStyle(group.status).name }}
              </div>
            <div class="required">{{ $tc('n_approvals_required', group.approvals_required, { count: group.approvals_required }) }}</div>
          </div>

          <ul class="approvers">
            <li
              v-for="(approver, index) in group.approvers"
              :key="index">
              <div
                class="status"
                :class="statusStyle(approver.response ? approver.response.status : 'stoped').bg">
                </div>
              <div class="name">
                <span v-tooltip="approver.email">
                  {{ approver.name }}
                </span>
              </div>
              <div class="comment"
                v-if="approver.response && approver.response.status">
                <div v-if="approver.response.comment" class="comment-text">{{ approver.response.comment }}</div>
                <div><small class="text-muted">{{ $d(new Date(approver.response.created_at), 'short') }}</small></div>
              </div>
            </li>
          </ul>

          <button 
            v-if="group.status === 'pending'"
            type="button" 
            class="btn mt-2 btn-sm btn-light" 
            @click="startApprovalflow()">
            {{ $t('Resend') }}
            </button>

        </li>
      </ul>
    </div>

    <div
      :class="{'box-loading': loading}"
      class="mt-3">
      <button
        v-if="approvalflow.status === 'stoped'"
        type="button" 
        class="btn btn-primary" 
        @click="startApprovalflow()">
        {{ $t('Start flow') }}
        </button>
      <!--<button 
      type="button" 
      class="btn btn-secondary" 
      @click="deleteApprovalflow()">
      {{ $t('Remove') }}
      </button>-->
    </div>

  </div>

</template>

<script>
export default {
  name: 'ApprovalflowProccess',
  components: {
  },
  props: {
    approvalflow: {
      type: Object
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    startApprovalflow () {
      this.loading = true

      this.$store
      .dispatch('startApprovalflow', this.approvalflow._id)
      .then((result) => {
        this.loading = false
      })
    },
    statusStyle (status) {
      return {
        pending: {
          name: this.$t('Pending'),
          style: 'text-warning',
          bg: 'bg-warning'
        },
        stoped: {
          name: this.$t('Stopped'),
          style: 'text-secondary',
          bg: 'bg-secondary'
        },
        approved: {
          name: this.$t('Approved'),
          style: 'text-success',
          bg: 'bg-success'
        },
        disapproved: {
          name: this.$t('Disapproved'),
          style: 'text-danger',
          bg: 'bg-danger'
        }
      }[status]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul.approval-list{
  list-style: none;
  margin: 0;
  padding: 0 0 0 1em;
  max-width: 800px;
}
  ul.approval-list > li{
    position: relative;
    padding: 1em 1em 1em 2em;
    border-left: 1px solid rgba(0,0,0,0.25);
  }
  ul.approval-list > li > .group-number{
    width: 2em;
    height: 2em;
    border-radius: 1em;
    border: 1px solid rgba(0,0,0,0.25);
    color: rgba(0,0,0,0.65);
    background: #ffffff;
    position: absolute;
    top: 1em;
    left: -1em;
    text-align: center;
    line-height: 1.8em;
    font-weight: bold;
  }
  ul.approval-list > li > .group-header{
    margin: 0 0 1em 0;
  }
    ul.approval-list > li > .group-header > .status{
      font-weight: bold;
    }
    ul.approval-list > li > .group-header > .required{
      font-style: italic;
    }
  ul.approval-list ul.approvers{
    list-style: none;
    padding: 0;
    margin: 0;
  }
  ul.approval-list ul.approvers > li{
    position: relative;
    padding-left: 18px;
    margin: 0.5em 0;
  }
    ul.approval-list ul.approvers > li > .status{
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background: #000000;
      position: absolute;
      top: 0.35em;
      left: 0;
    }
    ul.approval-list ul.approvers > li > .name{
      font-weight: bold;
    }
    ul.approval-list ul.approvers > li > .comment{
      color: rgba(0,0,0,0.65);
    }
    ul.approval-list ul.approvers > li > .comment > .comment-text{
      white-space: pre-wrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/Approvalflow/ApprovalflowProccess.vue